/**
 * Typed dot-path lookups from an enum value to its French message key
 * (`docs/CONVENTIONS.md` §1), the same pattern as `features/household/labels.ts`.
 */
import type { MessageKey } from '../../i18n/fr';
import type { CaseStage, FollowupStep } from '../../api/types';
import type { SequenceState } from './types';

/** A registration case's stage → its label on the Inscriptions table. */
export const CASE_STATUS_LABEL_KEYS: Record<CaseStage, MessageKey> = {
  info_given: 'admin.inscriptions.status.info_given',
  filed: 'admin.inscriptions.status.filed',
  confirmed: 'admin.inscriptions.status.confirmed',
  closed: 'admin.inscriptions.status.closed',
};

/** A case's derived follow-up state → its badge label. */
export const SEQUENCE_STATE_LABEL_KEYS: Record<SequenceState, MessageKey> = {
  none: 'admin.inscriptions.sequence.none',
  running: 'admin.inscriptions.sequence.running',
  stopped: 'admin.inscriptions.sequence.stopped',
  replied: 'admin.inscriptions.sequence.replied',
  unsubscribed: 'admin.inscriptions.sequence.unsubscribed',
  failed: 'admin.inscriptions.sequence.failed',
  completed: 'admin.inscriptions.sequence.completed',
};

/** A follow-up step (`j2`/`j7`/`j14`) → its short label ("J+2"). */
export const STEP_LABEL_KEYS: Record<FollowupStep, MessageKey> = {
  j2: 'admin.inscriptions.step.j2',
  j7: 'admin.inscriptions.step.j7',
  j14: 'admin.inscriptions.step.j14',
};
